import React, { Component } from 'react';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { Field, reduxForm } from 'redux-form';
import { Grid, Button, Typography, Container, CssBaseline, TextField, withStyles } from '@material-ui/core';
import { isMobile, isBrowser, isChrome } from 'react-device-detect';
import { history } from '../../helpers/history';
const validate = values => {
  const error = {}

  if (!values.identifier) {
    error.identifier = "El campo es obligatorio"
  }
  return error
}

const useStyles = theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: "1% 6% 6% 6%",
  },
  avatar: {
    margin: 1,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.primary.main
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: 1,
  },
  submit: {
    margin: (3, 0, 2),
    //fontFamily: 'FilsonProBold',
    fontSize: '0.9rem',
    color: 'white',
    backgroundColor: "#5A5759",
    "&:hover": {
      backgroundColor: "#5A5759"
    },
    borderRadius: "8px",
    border: "1px solid #fffffe"
  },
  logo: {
    width: '40%',
    height: '40%'
  },
  button_header: {
    marginTop: 20,
  },
  grid_header: {
    marginTop: 20,
  },
  copyright: {
    justifyContent: 'space-between'
  },
  title: {
    color: '#999999',
    //fontFamily: 'FilsonProBold'
    // //fontFamily: 'FilsonProBold',
    // fontSize: '200%'
  },
  button: {
    fontSize: '0.9rem',
    //fontFamily: 'FilsonProBold',

    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.secondary.main,
    },
    // borderRadius: "8px",
    // border: "1px solid #fffffe"
  },
});

// function Copyright(classes) {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center"  >
//       <Grid container className= {classes.grid_header} justify="center" alignItems="center" >
//         <Grid item xs={3}  className= {classes.button_header}>
//           <img src={process.env.PUBLIC_URL + '/images/copyright_icon.png'} alt="Logo" className={classes.logo}  />
//         </Grid>
//         <Grid item xs={6} justify="center" alignItems="center" >
//           <Link color="primary" href={ urlBase }>
//             <b>DERECHOS RESERVADOS</b>
//           </Link>{' '}
//         </Grid>
//       </Grid>          
//     </Typography>
//   );
// }
class Unlock extends Component {
  state = {}
  renderTextField = (
    { input, label, name, type, withFocus, meta: { touched, error } },
  ) => (
    <div>
      {/* <br/> */}
      {/* <Grid container spacing={1} justify="center" alignItems="center" direction="column" >
            <Grid item xs={12} md={12}>
              <span style={{color:'#999999', fontSize : "120%", //fontFamily : 'FilsonProBold'}}>{label}</span>
            </Grid>
          </Grid> */}
      <TextField
        {...input}
        type={!type ? "text" : type}
        variant="outlined"
        margin="normal"
        color='secondary'
        fullWidth
        name={label}
        id={label}
        label={label}
        // InputLabelProps= {
        //   {
        //     style: { color: '#fffffe'}
        //   }
        // }
        ref={withFocus && (txt => { this.txt = txt; })}
      // InputProps={{
      //   style : {
      //     height : "45px"
      //   },
      //   startAdornment: (
      //     <InputAdornment position="start" style={{backgroundColor: '#FFFFFF'}}>

      //     </InputAdornment>
      //   ),
      // }}
      />
    </div>
  );
  render() {
    const { classes, handleSubmit, pristine, submitting } = this.props; //,  valid, submitting
    return (
      <div>
        <Container component="main" maxWidth="xs">
          <CssBaseline />

          <div className={classes.paper}>
            <React.Fragment >
              <img src={process.env.PUBLIC_URL + '/images/logo_en_cl.png'} alt="Logo" className={classes.logo} />

              <br />

              {/* {
              isMobile ?
              <img src={process.env.PUBLIC_URL + '/images/logo_home.png'} alt="Logo" style={{width: '80%', height: '80%'}} /> :
              <img src={process.env.PUBLIC_URL + '/images/logo_home.png'} alt="Logo" style={{width: '80%', height: '80%'}} />
            } */}
              <div>
                <p style={{ padding: '15px' }}>
                  <Typography component="h1" variant="h5" >
                    {(isMobile && !isBrowser && !isChrome) ? 'Desbloquear Usuario' : 'Desbloquear Usuario'}
                  </Typography>
                </p>
              </div>
              <br />

              <form className={classes.form} onSubmit={handleSubmit} id="myForm">

                <Grid container spacing={3}>
                  <Grid item xs={12} md={12} lg={12} xl={12} >
                    <Field
                      withFocus
                      name="identifier"
                      component={this.renderTextField}
                      label="Escriba su identificación"
                    />
                  </Grid>
                </Grid>
                <br />


                <Grid container spacing={3}>
                  <Grid item xs={6} md={6} lg={6} xl={6} >
                    <Button
                      type="submit"
                      name="buttonSubmit"
                      disabled={pristine || submitting}
                      fullWidth
                      color="secondary"
                      variant="contained"
                      //className={classes.button}
                    >
                      Aceptar
                    </Button>
                  </Grid>
                  <Grid item xs={6} md={6} lg={6} xl={6} >
                    <Button
                      onClick={() => history.push('/login')}
                      variant="outlined"
                      color="secondary"
                      fullWidth
                      //className={classes.button}
                    > Atrás</Button>
                  </Grid>
                </Grid>
                <Grid item xs={12} className={classes.button_header} style={{ textAlign: 'center' }}>
                </Grid>
              </form>
            </React.Fragment>
          </div>
          {/* <Box mt={8}>
          <Copyright classes = {classes}/>
          </Box> */}
        </Container>
      </div>
    );
  }
}

Unlock.propTypes = {

};

const UnlockReduxForm = reduxForm(
  {
    form: 'UnlockdForm',
    validate
  }
)(Unlock)

// export default ChangePasswordForm;
export default setPropsAsInitial(withStyles(useStyles)(UnlockReduxForm))